import { useDispatch, useSelector } from "react-redux";

import ToastContainer from "layouts/Toastify";

import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

import { themeCreator } from "theme";
import { themesSelector } from "theme/selector";

import AppRouterProvider from "routes";
import { requestForToken } from "./firebase";
import { accountInfoDataSelector } from "layouts/Sidenav/redux/selector";
import { useLegacyEffect } from "helper/customHook";
import { useEffect, useState } from "react";
import { getMessaging, onMessage } from "firebase/messaging";
import { showNotification } from "helper/utils";
import {
  getListNotificationStart,
  resetListNotification,
} from "modules/Notification/redux/getListNoti";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import { updateDeviceStatusStart } from "modules/Notification/redux/updateDeviceStatus";
import { v4 as uuidv4 } from "uuid";
import { setAccountInfo } from "layouts/Sidenav/redux/accountInfo";

function App() {
  const { themeType } = useSelector(themesSelector);
  const themeApp = themeCreator(themeType);

  const [deviceId, setDeviceId] = useState(() =>
    localStorage.getItem("deviceId")
  );

  const dispatch = useDispatch();
  const { employeeCode, manager } = useSelector(accountInfoDataSelector);

  useLegacyEffect(() => {
    if (!employeeCode) {
      return;
    }

    if (!deviceId) {
      const newDeviceId = `${employeeCode}_${uuidv4()}-WEBSITE`;
      localStorage.setItem("deviceId", newDeviceId);
      setDeviceId(newDeviceId);
      return;
    }
    requestForToken(employeeCode, uuidv4(), () => {
      dispatch(
        setAccountInfo({
          notiActive: true,
        })
      );
    });
  }, [employeeCode, deviceId]);

  const getNewNotification = () => {
    dispatch(resetListNotification());
    dispatch(resetControlPage("notification"));
    dispatch(getListNotificationStart({ offset: 0, limit: 10, sort: "" }));
  };

  useEffect(() => {
    const messaging = getMessaging();
    const unsubscribe = onMessage(messaging, (payload) => {
      showNotification({ ...payload.data, manager });
      getNewNotification();
    });

    const messageHandler = (event) => {
      const { data } = event;
      if (data && data.type === "NEW_NOTIFICATION") {
        showNotification({ ...data.payload.data, manager });
        getNewNotification();
      }
    };

    navigator.serviceWorker.addEventListener("message", messageHandler);

    const handleBeforeUnload = () => {
      dispatch(
        updateDeviceStatusStart({
          name: deviceId,
          status: "INACTIVE",
        })
      );
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      unsubscribe();
      navigator.serviceWorker.removeEventListener("message", messageHandler);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch]);

  return (
    <ThemeProvider theme={themeApp}>
      <CssBaseline />
      <AppRouterProvider />
      <ToastContainer themeType={themeType} />
    </ThemeProvider>
  );
}
export default App;
